import { DatePickerProps } from "../iPicker";

export const getOptions = (picker: DatePickerProps['picker'], direction: DatePickerProps['direction'] = 'ltr'): {label: string; value: string; children?: any}[] => {
    // 获取cascader的options
    let nowDate = new Date()
    let currentYear: number = nowDate.getFullYear()
    let options = []
    let monthOptions = []
    for (let i = 1; i <= 12; i++) {
        let obj = {label: i + '月', value: i + '月'}
        monthOptions.push(obj)
    }
    if (!picker || picker === 'date' || picker === 'week') {
        for (let i = currentYear - 200; i < currentYear + 200; i++) {
            let obj = {label: i + '年', value: i + '年', children: monthOptions}
            options.push(obj)
        }
    } else if (picker === 'month' || picker === 'quarter' || picker === 'halfYear') {
        for (let i = currentYear - 200; i < currentYear + 200; i++) {
            let obj = {label: i + '年', value: i + '年'}
            options.push(obj)
        }
    } else if (picker === 'year') {
        for (let i = currentYear - 200; i < currentYear + 200; i++) {
            if (i % 10 === 0) {
                const label = direction === 'rtl' ? `${i + 9}-${i}` : `${i}-${i + 9}`
                let obj = {label, value: i + '-' + (i + 9)}
                options.push(obj)
            }
        }
    }
    return options
}
